<template>
  <div class="arrow">
    <img v-if="!isShow" src="../../../assets/images/winterGame/arrDown.png" />
    <img v-else src="../../../assets/images/winterGame/arrUp.png" />
  </div>
</template>

<script>
export default {
  name: "arrow",
  props: {},
  // data() {
  //   return {
  //     isSlide: true,
  //   };
  // },
  props: {
    isShow: false,
  },
  methods: {
    // handleClick() {
    //   this.isSlide = !this.isSlide;
    // },
  },
};
</script>

<style lang="less" scoped>
.arrow {
  img {
    width: 48px;
  }
}
</style>
